export class PermissionConfig {
  static admin: string[] = [
    'ModeratorsComponent',
    'StoreKeyComponent',
    'ConfigComponent',
    'DeletedUserIndexComponent',
    'StoreViewSnapshotsComponent'
  ];
}
